import apiClient from "./api";

export type DocumentoAprovacaoDTO = {
  id: number;
  proponente: {
    id: number;
    nome_completo: string;
    cpf: string;
    email: string;
  };
  documento_tipo: string;
  status: string;
  aprovado_por: any | null;
  aprovado_em: string | null;
  observacoes: string | null;
  arquivo: { filename: string; url: string } | null;
  created_at: string;
  updated_at: string;
};

export const fetchPendingDocumentoAprovacoes = async (): Promise<
  DocumentoAprovacaoDTO[]
> => {
  const resp = await apiClient.get(
    "/api/v1/admin/documento_aprovacoes/pendentes"
  );
  return resp.data.documento_aprovacoes as DocumentoAprovacaoDTO[];
};

export const aprovarDocumento = async (id: number, observacoes?: string) => {
  const resp = await apiClient.post(
    `/api/v1/admin/documento_aprovacoes/${id}/aprovar`,
    { observacoes }
  );
  return resp.data;
};

export const reprovarDocumento = async (id: number, observacoes?: string) => {
  const resp = await apiClient.post(
    `/api/v1/admin/documento_aprovacoes/${id}/reprovar`,
    { observacoes }
  );
  return resp.data;
};

export type ProponenteAdminSummary = {
  id: number;
  nome_completo: string;
  email: string;
  cpf: string;
  documentos_pendentes: boolean;
  todos_documentos_aprovados: boolean;
  algum_documento_reprovado: boolean;
};

export const fetchProponentesAdmin = async (): Promise<
  ProponenteAdminSummary[]
> => {
  const resp = await apiClient.get("/api/v1/admin/proponentes");
  return resp.data.proponentes as ProponenteAdminSummary[];
};

export type HistoricoDocumento = {
  id: number;
  status: string;
  aprovado_por: string | null;
  aprovado_em: string | null;
  observacoes: string | null;
  created_at: string;
  arquivo?: { filename: string; url: string } | null;
};

export type ProponenteAdminDetail = {
  id: number;
  nome_completo: string;
  email: string;
  cpf: string;
  documentos_pendentes: boolean;
  documentos: Array<{
    id: number;
    documento_tipo: string;
    status: string;
    aprovado_por: string | null;
    aprovado_em: string | null;
    observacoes: string | null;
    arquivo?: { filename: string; url: string } | null;
    created_at?: string;
    updated_at?: string | null;
    tem_historico?: boolean;
    total_envios?: number;
    historico?: HistoricoDocumento[];
  }>;
};

export const fetchProponenteAdmin = async (
  id: number
): Promise<ProponenteAdminDetail> => {
  const resp = await apiClient.get(`/api/v1/admin/proponentes/${id}`);
  return resp.data.proponente as ProponenteAdminDetail;
};

export default {
  fetchPendingDocumentoAprovacoes,
  aprovarDocumento,
  reprovarDocumento,
};
